var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppleStoreMark = function SvgAppleStoreMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0458 20.275C16.066 21.2248 14.9963 21.0748 13.9666 20.6249C12.8768 20.165 11.8771 20.1451 10.7274 20.6249C9.28771 21.2448 8.5279 21.0648 7.66811 20.275C2.78931 15.2463 3.50914 7.69811 9.04777 7.39819C10.3974 7.46817 11.3372 8.138 12.127 8.19799C13.3067 7.95805 14.4364 7.26822 15.6961 7.3582C17.2058 7.47817 18.3455 8.07802 19.0953 9.15775C15.9761 11.0273 16.7159 15.1363 19.5752 16.286C19.0053 17.6757 18.2555 19.0453 17.0358 20.275H17.0458ZM12.027 7.24822C11.8771 5.01877 13.6866 3.17922 15.7661 2.99927C16.0561 5.57863 13.4267 7.49816 12.027 7.24822Z",
    fill: "white"
  })));
};
export default SvgAppleStoreMark;